import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { createColumns, csx } from '@vtex/admin-ui'
import { useAdmin } from '@vtex/raccoon-next'
import { ActionsCell } from '@/components/products-listing/components'
import type { Product } from '@/types/product'

import { SkuListAction } from '../components'
import { PlainCell } from '../plain-cell'
import { ProductCell } from '../product-cell'

import * as style from '../products-listing.styles'

export enum ColumnsIDs {
  SKU_ACTION = 'sku-action',
  NAME = 'name',
  LAST_UPDATE = 'lastUpdate',
  MENU = 'menu',
}

export const useProductListTableColumns = () => {
  return useMemo(
    () =>
      createColumns<Product>([
        {
          id: ColumnsIDs.SKU_ACTION,
          width: '64px',
          header: () => <div aria-hidden="true" />,
          resolver: {
            type: 'root',
            render: SkuListAction,
          },
        },
        {
          id: ColumnsIDs.NAME,
          width: 'minmax(50%, auto)',
          header: () => (
            <FormattedMessage
              id="admin/admin.catalog.name-table-header"
              defaultMessage="Name"
            />
          ),
          resolver: {
            type: 'root',
            render: ProductCell,
          },
        },
        {
          id: ColumnsIDs.LAST_UPDATE,
          width: 'fit-content(200px)',
          sortable: true,
          header: () => (
            <span className={csx(style.lastUpdatedHeader)}>
              <FormattedMessage
                id="admin/admin.catalog.last-update-table-header"
                defaultMessage="Last Update"
              />
            </span>
          ),
          resolver: {
            type: 'root',
            render: function Render({ item, context }) {
              const { locale } = useAdmin()

              if (!item.lastUpdateDate) {
                return (
                  <PlainCell context={context}>
                    <FormattedMessage
                      id="admin/admin.catalog.date-undefined"
                      defaultMessage="Undefined"
                    />
                  </PlainCell>
                )
              }

              const lastUpdateDate = new Date(item.lastUpdateDate)

              return (
                <PlainCell context={context}>
                  {lastUpdateDate.toLocaleDateString(locale, {
                    year: '2-digit',
                    month: 'short',
                    day: 'numeric',
                  })}
                </PlainCell>
              )
            },
          },
        },
        {
          id: ColumnsIDs.MENU,
          width: 'min-content',
          resolver: {
            type: 'root',
            render: ActionsCell,
          },
        },
      ]),
    []
  )
}
